module.exports = __webpack_public_path__ + "assets/img/detail-btn-d0265762.png";